// Shared CPSC parsing helpers (CHA-168, extracted CHA-175) so the CPSC surfaces (BV Upload, etc.)
// share one strict date parser instead of duplicating it (§8.2 — don't grow the date-format zoo).
// Pure functions, no React / Firebase deps.

/**
 * parseMdy — strict MM/DD/YYYY parser. Mirrors the server's SAFE.PARSE_DATE('%m/%d/%Y', …) so the
 * client's "no/invalid date" markers agree with what the server kept as unparseable. Date.parse is
 * lenient (rolls 02/31 into March, accepts odd formats), which would under-mark rows the server
 * rejected — hence this exact, calendar-validated parser. Returns a Date or null.
 */
export function parseMdy(v) {
  const str = String(v ?? '').trim();
  const m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(str);
  if (!m) return null;
  const mo = +m[1], da = +m[2], yr = +m[3];
  const d = new Date(yr, mo - 1, da);
  return (d.getFullYear() === yr && d.getMonth() + 1 === mo && d.getDate() === da) ? d : null;
}
